import '../static/scrollbar/jquery.scrollbar.js'
import '../static/scrollbar/jquery.scrollbar.css'
import { methods } from './_methods'

export const _dropdown = {
  active() {
    let check = function() {
      if(window.innerWidth >= 1201) return true
      else return false
    }

    if(check()) {
      // 高度會抓不準所以 + setTimeout
      setTimeout(() => {
        _dropdown.desktop();
      }, 100)
    }
    else _dropdown.mobile();
  },

  // 電腦版
  desktop() {
    let page = $('body').attr('data-page-type');
    let $dropdown = $('.row-dropdown.desktop');
    let $spread = $('.btn-spread');

    if($spread.length !== 0) true 
    else return

    $dropdown.each((index, el) => {
      let maxH = $(el).find('li').outerHeight();
      let originH = $(el).find('ul').outerHeight();
      let wrap = $(el).find('.dropdown-desk');
      let li = $(el).find('li');
      let spread = $(el).find('.btn-spread');
      wrap.attr('data-maxh', maxH);
      wrap.css('height', maxH);
      // 超過高度啟用展開按鈕
      if(originH > maxH) {
        $(el).addClass('active');
        spread.addClass('active');
        // 展開選項
        spread.on('click',function(e) {
          e.stopPropagation();
          if(!spread.hasClass('show')) {
            spread.addClass('show');
            wrap.css('height', originH);
          } else{
            spread.removeClass('show');
            wrap.css('height', maxH);
          }
        });
      }
      // 切換 active
      methods.lickSwitchClass(li, 'active');
    });

    $('.dropdown-wrap').on('click', function(e) {
      e.stopPropagation()
    });
    // 點擊旁邊收合
    $('body').on('click', function() {
      $('.btn-spread').removeClass('show');
      $dropdown.each((index, el) => {
        let maxH = $(el).find('.dropdown-desk').attr('data-maxh');
        $(el).find('.dropdown-desk').css('height', maxH);
      });
    });
  },

  // 手機板
  mobile() {
    let dropdown = $('.row-dropdown.drop.mobile .dropdown-mobile');
    dropdown.each((index, el) => {
      let replaceText = $(el).attr('data-replace');
      let li = $(el).parent('.row-dropdown').find('li');

      $(el).off().on('click',function() {
        let vm = $(el);

        if(!vm.hasClass('active')) {
          vm.addClass('active');
          vm.parents('.row-dropdown.drop.mobile').find('.scrollbar').slideDown(400);
        } else {
          close();
        }

        // 其他收合
        $('.row-dropdown').removeClass('slide-now');
        vm.parent('.row-dropdown').addClass('slide-now');
        $('.row-dropdown:not(.slide-now) .dropdown-mobile').removeClass('active');
        $('.row-dropdown:not(.slide-now) .scrollbar').slideUp(400);
      });
      // 替換文字
      li.on('click', function() {
        let val = $(this).text();
        let replaceEl = $(this).parents('.row-dropdown.mobile').find('.dropdown-mobile span');
        if(replaceText === 'true') {
          replaceEl.text(val);
          close();
        } else {
          close();
        };
      });
    });

    $('.row-dropdown.drop.mobile').on('click', function(e) {
      e.stopPropagation();
    })

    $('body').on('click', function() {
      if(window.innerWidth <= 1200) close();
    });

    // 關閉
    function close() {
      $('.row-dropdown.drop.mobile .dropdown-mobile').removeClass('active');
      $('.row-dropdown.drop.mobile .scrollbar').slideUp(400);
    }
  },

  // mobile JS only
  mobileOnly() {
    _dropdown.mobile();
    $('.row-dropdown.mobile [data-scrollbar]').scrollbar();
  },

  // 電腦版下拉選單
  deskDropdown() {
    let dropdown = $('.row-dropdown.type-show .dropdown-mobile');
    dropdown.each((index, el) => {
      let replaceText = $(el).attr('data-replace');
      let li = $(el).parent('.row-dropdown').find('li');

      $(el).off().on('click',function() {
        let vm = $(el);

        if(!vm.hasClass('active')) {
          vm.addClass('active');
          vm.parents('.row-dropdown.type-show').find('.scrollbar').slideDown(400);
        } else {
          close();
        }

        // 其他收合
        $('.row-dropdown').removeClass('slide-now');
        vm.parent('.row-dropdown').addClass('slide-now');
        $('.row-dropdown:not(.slide-now) .dropdown-mobile').removeClass('active');
        $('.row-dropdown:not(.slide-now) .scrollbar').slideUp(400);
      });
      // 替換文字
      li.on('click', function() {
        let val = $(this).text();
        let replaceEl = $(this).parents('.row-dropdown.type-show').find('.dropdown-mobile span');
        if(replaceText === 'true') {
          replaceEl.text(val);
          close();
        } else {
          close();
        };
      });
    });

    $('.row-dropdown.type-show').on('click', function(e) {
      e.stopPropagation();
    });

    $('body').on('click', function() {
      close();
    });

    $('.row-dropdown.type-show [data-scrollbar]').scrollbar();
    // 關閉
    function close() {
      $('.row-dropdown.type-show .dropdown-mobile').removeClass('active');
      $('.scrollbar').slideUp(400);
    }
  },

  all() {
    _dropdown.active();
    $('.row-dropdown.mobile [data-scrollbar]').scrollbar();
    methods.resize(_dropdown.active);
  }
}
